import { inject, Injectable, isDevMode } from '@angular/core';
import { SupabaseSession } from '@itavan/lib/core/supabase';
import { AuthApiError } from '@supabase/supabase-js';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private session = inject(SupabaseSession);

  async signInWithEmailPassword(email: string, password: string) {
    const { data, error } = await this.session.signInWithPassword({ email, password });
    if (error) {
      if (error instanceof AuthApiError) {
        throw new Error(error.code);
      }
      throw new Error('UNEXPECTED');
    }
    return data;
  }

  async sendMagicLink(email: string, lang: string = 'es') {
    return await this.session.sendMagicLink(email, lang);
  }
}

export function getSignInErrorMessage(code: string): string {
  isDevMode() && console.log('code', code);
  switch (code) {
    case 'invalid_credentials':
      return 'Credenciales inválidas';
    case 'user_not_found':
      return 'Usuario no encontrado';
    case 'user_inactive':
      return 'Usuario inactivo';
    case 'email_not_confirmed':
      return 'Correo no confirmado';
    case 'UNAUTHORIZED':
      return 'No autorizado';
    default:
      return 'Error inesperado al iniciar sesión';
  }
}
